/* GENERATED FROM graphQueryMgr.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'
import * as commonHdr from './commonHdr.service'

export class GraphQueryMgr {
  static AutoCompleteQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<AutoCompleteQueryReq, {}, AutoCompleteQueryResp>): Promise<
    APIResponse<AutoCompleteQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/autocomplete`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<AutoCompleteQueryResp>>()
          .then<APIResponse<AutoCompleteQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static AutoCompleteQueryUser = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<AutoCompleteQueryReq, {}, AutoCompleteQueryResp>): Promise<
    APIResponse<AutoCompleteQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/autocomplete-user`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<AutoCompleteQueryResp>>()
          .then<APIResponse<AutoCompleteQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static DashBoardQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<DashBoardQueryReq, {}, DashBoardQueryResp>): Promise<
    APIResponse<DashBoardQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/dashboard`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<DashBoardQueryResp>>()
          .then<APIResponse<DashBoardQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static IdentityQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<IdentityQueryReq, {}, IdentityQueryResp>): Promise<
    APIResponse<IdentityQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/identity`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<IdentityQueryResp>>()
          .then<APIResponse<IdentityQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static IdentityServiceQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<
    IdentityServiceQueryReq,
    {},
    IdentityServiceQueryResp
  >): Promise<APIResponse<IdentityServiceQueryResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/identity-service`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<IdentityServiceQueryResp>>()
          .then<APIResponse<IdentityServiceQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static PrivilegePageQuery = ({
    params,
    queryVars,
    options,
    makeRequestOptions
  }: APIRequest<
    PrivilegePageQueryReq,
    { view_type: string },
    PrivilegePageQueryResp
  >): Promise<APIResponse<PrivilegePageQueryResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/privileges/${queryVars.view_type}`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<PrivilegePageQueryResp>>()
          .then<APIResponse<PrivilegePageQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static PrivilegeUsersQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<PrivilegeUsersQueryReq, {}, PrivilegeUsersQueryResp>): Promise<
    APIResponse<PrivilegeUsersQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/privilege-users`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<PrivilegeUsersQueryResp>>()
          .then<APIResponse<PrivilegeUsersQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static NetworkQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<NetworkQueryReq, {}, NetworkQueryResp>): Promise<
    APIResponse<NetworkQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/networks`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<NetworkQueryResp>>()
          .then<APIResponse<NetworkQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static NetworkServiceQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<NetworkServiceQueryReq, {}, NetworkServiceQueryResp>): Promise<
    APIResponse<NetworkServiceQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/network-service`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<NetworkServiceQueryResp>>()
          .then<APIResponse<NetworkServiceQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ObjectQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ObjectQueryReq, {}, ObjectQueryResp>): Promise<
    APIResponse<ObjectQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/objects`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ObjectQueryResp>>()
          .then<APIResponse<ObjectQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ObjectServiceQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ObjectServiceQueryReq, {}, ObjectServiceQueryResp>): Promise<
    APIResponse<ObjectServiceQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/objects-service`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ObjectServiceQueryResp>>()
          .then<APIResponse<ObjectServiceQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static PublicObjectQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<PublicObjectQueryReq, {}, PublicObjectQueryResp>): Promise<
    APIResponse<PublicObjectQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/public-objects`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<PublicObjectQueryResp>>()
          .then<APIResponse<PublicObjectQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static ShadowAccessQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ShadowAccessQueryReq, {}, ShadowAccessQueryResp>): Promise<
    APIResponse<ShadowAccessQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/shadow-access`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ShadowAccessQueryResp>>()
          .then<APIResponse<ShadowAccessQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static CloseSearchSession = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<CloseSearchSessionReq, {}, CloseSearchSessionResp>): Promise<
    APIResponse<CloseSearchSessionResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/close-session`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<CloseSearchSessionResp>>()
          .then<APIResponse<CloseSearchSessionResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static AccountQuery = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<AccountQueryReq, {}, AccountQueryResp>): Promise<
    APIResponse<AccountQueryResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/account`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<AccountQueryResp>>()
          .then<APIResponse<AccountQueryResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static UnusedAccess = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UnusedAccessReq, {}, UnusedAccessResp>): Promise<
    APIResponse<UnusedAccessResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/graph-querymgr/unused-accesses`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UnusedAccessResp>>()
          .then<APIResponse<UnusedAccessResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static HealthStatus = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<HealthStatusReq, {}, HealthStatusResp>): Promise<
    APIResponse<HealthStatusResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/beta/healthStatus`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<HealthStatusResp>>()
          .then<APIResponse<HealthStatusResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static BetaGetGroup = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetGroupReq, {}, GetGroupResp>): Promise<
    APIResponse<GetGroupResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/resources/groups`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetGroupResp>>()
          .then<APIResponse<GetGroupResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetScope = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetScopeReq, {}, GetScopeResp>): Promise<
    APIResponse<GetScopeResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/resources/scopes`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetScopeResp>>()
          .then<APIResponse<GetScopeResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetService = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetServiceReq, {}, GetServiceResp>): Promise<
    APIResponse<GetServiceResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/resources/services`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetServiceResp>>()
          .then<APIResponse<GetServiceResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetRole = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetRoleReq, {}, GetRoleResp>): Promise<
    APIResponse<GetRoleResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/resources/roles`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetRoleResp>>()
          .then<APIResponse<GetRoleResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static InitiateDataDownload = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<
    InitiateDataDownloadReq,
    {},
    InitiateDataDownloadResp
  >): Promise<APIResponse<InitiateDataDownloadResp>> =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/graph-querymgr/v1/resources/publish`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<InitiateDataDownloadResp>>()
          .then<APIResponse<InitiateDataDownloadResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface UserCountInfo {
  user_count?: number
  active_user_count?: number
}

export interface DataCountInfo {
  object_count?: number
  public_object_count?: number
}

export interface PrivilegeCountInfo {
  privilege_count?: number
  used_privilege_count?: number
}

export interface InstanceCountInfo {
  instance_count?: number
  public_instance_count?: number
}

export interface NetworkCountInfo {
  network_count?: number
  public_network_count?: number
}

export interface PublicObjectsCountInfo {
  source_type?: commonHdr.ResourceTypeEnum
  public_count?: number
}

export interface ShadowAccessCountInfo {
  network_count?: number
  account_count?: number
}

export interface SensitivePrivilegeInfo {
  total_unused?: number
  by_role_count?: number
  by_identity_w_role_count?: number
  by_identity_wo_role_count?: number
}

export interface DashBoardQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  account_uid?: string
}

export interface DashBoardQueryResp {
  resp_hdr?: base.RespHdr
  account_id?: string
  account_uid?: string
  account_count?: number
  user_info?: UserCountInfo
  data_info?: DataCountInfo
  privilege_info?: PrivilegeCountInfo
  instance_info?: InstanceCountInfo
  network_info?: NetworkCountInfo
  result_graph?: string
  result_table?: commonHdr.SearchResultTableRow[]
  public_objects_info?: PublicObjectsCountInfo[]
  shadow_access_info?: ShadowAccessCountInfo
  sensitive_privilege_info?: SensitivePrivilegeInfo
}

export interface UserDataInfo {
  priv_total?: number
  priv_used?: number
  roles_count?: number
  used_roles_count?: number
  groups_count?: number
  role_tile_info?: RoleTileInfo[]
  privilege_tile_info?: PrivilegeTileInfo[]
}

export interface GroupDataInfo {
  members?: number
  privileges?: number
  member_tile_info?: MemberTileInfo[]
  privilege_tile_info?: PrivilegeTileInfo[]
}

export interface RoleDataInfo {
  priv_total?: number
  priv_used?: number
  users_total?: number
  users_used?: number
  instances_total?: number
  instances_used?: number
  user_tile_info?: UserTileInfo[]
  instance_tile_info?: InstanceTileInfo[]
  privilege_tile_info?: PrivilegeTileInfo[]
  scope_used?: number
  scope_total?: number
  scope_tile_info?: ScopeTileInfo[]
}

export interface ServiceAccountDataInfo {
  priv_total?: number
  priv_used?: number
  roles_count?: number
  used_roles_count?: number
  groups_count?: number
  role_tile_info?: RoleTileInfo[]
  privilege_tile_info?: PrivilegeTileInfo[]
}

export interface ScopeDataInfo {
  priv_total?: number
  priv_used?: number
  users_total?: number
  users_used?: number
  instances_total?: number
  instances_used?: number
  user_tile_info?: UserTileInfo[]
  instance_tile_info?: InstanceTileInfo[]
  privilege_tile_info?: PrivilegeTileInfo[]
  role_name?: string
  scope?: string
}

export interface ScopeTileInfo {
  name?: string
  uri?: string
  last_active_time?: number
  scope?: string
}

export interface IdentityCount {
  user_count?: number
  group_count?: number
  role_count?: number
  instance_count?: number
  azure_service_principal_count?: number
  gcp_service_account_count?: number
}

export interface IdentitySummaryInfo {
  account_id?: string
  entity_id?: string
  group_count?: number
  last_active_time?: string
  name?: string
  priv_total?: number
  priv_used?: number
  resources_total?: number
  resources_used?: number
  roles_total?: number
  roles_used?: number
  type?: string
  users_total?: number
  users_used?: number
  instances_total?: number
  instances_used?: number
  enterprise_directory?: string
  scope_cnt?: number
  scope_uri?: string
  iga_identity_id?: string
  iga_display_name?: string
  iga_first_name?: string
  iga_last_name?: string
  iga_life_cycle_state?: string
  iga_user_name?: string
}

export interface IdentityInfo {
  valueMap?: string
  auto_complete_resp?: AutoCompleteQueryResp
  object_count?: number
  used_object_count?: number
  user_info?: UserDataInfo
  group_info?: GroupDataInfo
  role_info?: RoleDataInfo
  service_account_info?: ServiceAccountDataInfo
  scope_info?: ScopeDataInfo
  privilege_tile_info?: PrivilegeTileInfo[]
  policy_list?: string[]
  member_tile_info?: MemberTileInfo[]
  scope_tile_info?: ScopeTileInfo[]
  instance_tile_info?: InstanceTileInfo[]
  user_tile_info?: UserTileInfo[]
  roll_up_graph?: RollUpGraphItem[]
  result_graph?: string
  result_table?: commonHdr.SearchResultTableRow[]
  role_tile_info?: RoleTileInfo[]
}

export interface RollUpGraphItem {
  identity?: string
  identity_uri?: string
  resource_type?: commonHdr.ResourceTypeEnum
  resource_count?: number
}

export interface IdentityQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
  uri?: string
}

export interface IdentityServiceQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
  uri?: string
  resource_uri?: string
  resource_type?: string
  data_type?: DataType
  tile?: IdentityTileType
}

export interface IdentityQueryResp {
  resp_hdr?: base.RespHdr
  identity_count?: IdentityQueryResp_IdentityCountEntry
  identity_summary_info?: IdentitySummaryInfo[]
  identity_info?: IdentityInfo
}

export interface IdentityQueryResp_IdentityCountEntry {
  [key: string]: number
}

export interface IdentityServiceQueryResp {
  resp_hdr?: base.RespHdr
  identity_info?: IdentityInfo
}

export interface NetworkServiceQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
  uri?: string
  resource_uri?: string
  resource_type?: string
  data_type?: DataType
  tile?: NetworkTileType
  tableTab?: NetworkTableTab
}

export interface AutoCompleteQueryReq {
  req_hdr?: base.ReqHdr
  input?: string
  account_id?: string
  session_props?: SessionSearchQueryProps
}

export interface SessionSearchQueryProps {
  session_id?: string
  batch_size?: number
  is_next?: boolean
}

export interface AutoCompleteQueryInternalReq {
  autocomplete_req?: AutoCompleteQueryReq
  tenant_id?: string
}

export interface PropertyInfo {
  is_not?: boolean
  value?: string
}

export interface OperatorInfo {
  label?: string
  properties?: OperatorInfo_PropertiesEntry
  property_operator?: string
}

export interface OperatorInfo_PropertiesEntry {
  [key: string]: PropertyInfo
}

export interface AutoCompleteQueryState {
  new_state?: queryFsmState
  num_spaces?: number
  type?: commonHdr.ResourceTypeEnum
  stage?: FSMStage
  attr_key?: string
  src_operator_info?: OperatorInfo[]
  src_operator?: string
  dst_operator_info?: OperatorInfo[]
  dst_operator?: string
  edge_operator_info?: OperatorInfo[]
  edge_operator?: string
  bucket_name?: string
  object_name?: string
  usage_operator?: string
  usage_operand?: number
  xaccount?: boolean
  priv_operator?: string
  priv_operator_info?: OperatorInfo[]
  account_id?: string
  session_id?: string
  batch_size?: number
}

export interface ResourceDetails {
  type?: string
  account_id?: string
  name?: string
  URI?: string
  native_id?: string
  cloud_type?: base.CloudTypeEnum
}

export interface AutoCompleteQueryResp {
  resp_hdr?: base.RespHdr
  options?: string[]
  result_graph?: string
  result_table?: commonHdr.SearchResultTableRow[]
  identities?: ResourceDetails[]
  objects?: ResourceDetails[]
  policies?: ResourceDetails[]
  resp_type?: AutoCompleteRespTypeEnum
  usage_resp?: commonHdr.AutoCompleteUsedInResp
  has_next?: boolean
  has_prev?: boolean
}

export interface UpdateCacheReq {
  req_hdr?: base.ReqHdr
}

export interface UpdateCacheInternalReq {
  data?: UpdateCacheReq
  tenant_id?: string
  use_cache?: boolean
  ignore_version?: boolean
  user_id?: string
}

export interface StatsGraphReq {
  req_hdr?: base.ReqHdr
  stats_query?: string
}

export interface StatsGraphInternalReq {
  statsgraph_req?: StatsGraphReq
  tenant_id?: string
  use_cache?: boolean
}

export interface StatsGraphResp {
  resp_hdr?: base.RespHdr
  response?: string
}

export interface RenderGraphReq {
  req_hdr?: base.ReqHdr
  query?: string
}

export interface RenderGraphInternalReq {
  render_graph_req?: RenderGraphReq
  tenant_id?: string
}

export interface RenderGraphResp {
  resp_hdr?: base.RespHdr
  response?: string
  result_table?: commonHdr.SearchResultTableRow[]
}

export interface RenderLayoutInternalReq {
  req_hdr?: base.ReqHdr
  render_graph?: RenderGraphStruct
  tenant_id?: string
}

export interface RenderLayoutInternalResp {
  resp_hdr?: base.RespHdr
  render_nodes?: RenderGraphNodeStruct[]
}

export interface RenderGraphNodeStruct {
  num?: string
  typer?: number
  id?: string
  name?: string
  account_id?: string
  region?: string
  x?: string
  y?: string
  size?: string
  cluster?: number
  action?: number
  profile_present?: boolean
}

export interface RenderGraphEdgeStruct {
  source?: string
  target?: string
  mlink?: string
  admin?: boolean
  action?: number
  risk?: string
}

export interface RenderGraphPathStruct {
  id?: string
  policy_list?: string[]
  action_list?: string[]
  admin?: boolean
  risk?: string
  idp_account_name?: string
}

export interface RenderGraphStruct {
  nodes?: RenderGraphNodeStruct[]
  links?: RenderGraphEdgeStruct[]
  paths?: RenderGraphPathStruct[]
}

export interface ObjectQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
  uri?: string
}

export interface ObjectDetailInfo {
  valueMap?: string
  auto_complete_resp?: AutoCompleteQueryResp
  user_cnt?: number
  admin_cnt?: number
  group_cnt?: number
  role_cnt?: number
  svc_count?: number
  result_table?: commonHdr.SearchResultTableRow[]
  policy_list?: string[]
  roll_up_graph?: ObjectRollUpGraphItem[]
}

export interface ObjectRollUpGraphItem {
  resource?: string
  resource_uri?: string
  identity_type?: commonHdr.ResourceTypeEnum
  identity_count?: number
}

export interface ObjectSummaryInfo {
  name?: string
  entity_id?: string
  type?: string
  read_cnt?: number
  write_cnt?: number
  admin_cnt?: number
  used_read_cnt?: number
  used_write_cnt?: number
  used_admin_cnt?: number
  profile_cnt?: number
  account_id?: string
}

export interface ObjectCount {
  name?: string
  entity_id?: string
  type?: string
  user_cnt?: number
  privilege_cnt?: number
}

export interface ObjectQueryResp {
  resp_hdr?: base.RespHdr
  object_summary_info?: ObjectSummaryInfo[]
  object_detail_info?: ObjectDetailInfo
}

export interface ObjectServiceQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
  uri?: string
  data_type?: DataType
  identity_uri?: string
  identity_type?: string
  tile?: ObjectTileType
}

export interface ObjectServiceQueryResp {
  resp_hdr?: base.RespHdr
  object_detail_info?: ObjectDetailInfo
}

export interface TagInfo {
  name?: string
  value?: string
}

export interface NetworkQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
  uri?: string
  network?: boolean
}

export interface NetworkSummaryInfo {
  account_id?: string
  region_name?: string
  uri?: string
  tag_info?: TagInfo[]
  name?: string
  subnet_count?: number
  instance_count?: number
  sg_count?: number
  vpc?: string
}

export interface NetworkDetailInfo {
  valueMap?: string
  auto_complete_resp?: AutoCompleteQueryResp
  user_count?: number
  group_count?: number
  role_count?: number
  objects_total?: number
  objects_used?: number
  roles_used?: number
  sg_detail?: string
  instances_count?: number
  sg_count?: number
  subnets_count?: number
  ports_count?: number
  routes_count?: number
  net_instance_info?: NetInstanceInfo[]
  net_sg_info?: NetSgInfo[]
  net_subnet_info?: NetSubnetInfo[]
  sg_info?: commonHdr.CommonSGInfo
  instance_role_details?: InstanceRoleDetails[]
  routes?: commonHdr.RouteInfo[]
  roll_up_graph?: RollUpGraphItem[]
  policy_list?: string[]
}

export interface NetInstanceInfo {
  name?: string
  region?: string
  tag_info?: TagInfo[]
  subnet?: string
  ssh_key?: string
  uri?: string
  account_id?: string
  public_ip?: string
}

export interface NetSgInfo {
  name?: string
  instance_count?: number
  tag_info?: TagInfo[]
  rules?: string
  uri?: string
  account_id?: string
}

export interface NetSubnetInfo {
  name?: string
  instance_count?: number
  tag_info?: TagInfo[]
  cidr?: string
  uri?: string
  account_id?: string
}

export interface NetPortInfo {
  ip_permissions_egress?: string
  ip_permissions?: string
}

export interface InstanceRoleDetails {
  name?: string
  entity_id?: string
  account_id?: string
  vpc_count?: number
  net_count?: number
  last_active_time?: number
  used_read_count?: number
  used_write_count?: number
  used_admin_count?: number
  total_read_count?: number
  total_write_count?: number
  total_admin_count?: number
}

export interface NetworkQueryResp {
  resp_hdr?: base.RespHdr
  network_count?: NetworkQueryResp_NetworkCountEntry
  network_summary_info?: NetworkSummaryInfo[]
  network_detail_info?: NetworkDetailInfo
}

export interface NetworkQueryResp_NetworkCountEntry {
  [key: string]: number
}

export interface NetworkServiceQueryResp {
  resp_hdr?: base.RespHdr
  network_detail_info?: NetworkDetailInfo
}

export interface PrivilegeSummary {
  service_label?: string
  name?: string
  account_id?: string
  users_total?: number
  users_unused?: number
  last_used?: number
  used_90?: number
  used_30?: number
  used_7?: number
}

export interface PrivilegePageQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  limit?: number
  session_id?: string
  direction?: base.ServerPagingDirection
  view_type?: PrivilegePageQueryReq_PrivilegeViewType
}

export enum PrivilegePageQueryReq_PrivilegeViewType {
  ALL = 'ALL',
  USED = 'USED',
  UNUSED = 'UNUSED'
}

export interface PrivilegePageQueryResp {
  resp_hdr?: base.RespHdr
  privilege_summary?: PrivilegeSummary[]
  has_next?: boolean
  has_prev?: boolean
}

export interface PrivilegeChartQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
}

export interface PrivilegeChart {
  action?: string
  users?: number
  users_using?: number
}

export interface PrivilegeChartQueryResp {
  resp_hdr?: base.RespHdr
  privilege_chart?: PrivilegeChart[]
}

export interface PrivilegeUsersQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  privilege?: string
}

export interface PrivilegeUsersInfo {
  uri?: string
  name?: string
  is_used?: boolean
}

export interface PrivilegeUsersQueryResp {
  resp_hdr?: base.RespHdr
  users?: PrivilegeUsersInfo[]
}

export interface PublicObjectQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
}

export interface EntityCount {
  type?: string
  count?: number
}

export interface EntityInfo {
  read_action_count?: number
  admin_action_count?: number
  write_action_count?: number
  via_policy?: string[]
  account_id?: string
  region?: string
  uri?: string
  name?: string
  tag_info?: TagInfo[]
  objects?: string
}

export interface PublicObjectQueryResp {
  resp_hdr?: base.RespHdr
  public_objects_info?: PublicObjectsCountInfo[]
  entity_info?: EntityInfo[]
}

export interface ShadowAccountDetail {
  shadow_account_id?: string
  account_id?: string
  resources_available?: number
  name?: string
}

export interface ShadowNetwork {
  uri?: string
  name?: string
  account_id?: string
  out_sg?: number
  out_obj_store?: number
}

export interface AccountQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
}

export interface AccountQueryResp {
  resp_hdr?: base.RespHdr
  valueMap?: string
}

export interface ShadowAccessQueryReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  type?: string
}

export interface ShadowAccessQueryResp {
  resp_hdr?: base.RespHdr
  unknown_account?: ShadowAccountDetail[]
  known_account?: ShadowAccountDetail[]
  shadow_network?: ShadowNetwork[]
}

export interface CloseSearchSessionReq {
  req_hdr?: base.ReqHdr
  session_id?: string
}

export interface CloseSearchSessionResp {
  resp_hdr?: base.RespHdr
}

export interface MemberTileInfo {
  name?: string
  entity_id?: string
  account_id?: string
  type?: string
  last_active_time?: number
  group_cnt?: number
  role_cnt?: number
}

export interface PrivilegeTileInfo {
  uri?: string
  name?: string
  service_name_label?: string
  account_id?: string
  policies?: string[]
  policies_count?: number
  last_used?: number
  used_7?: number
  used_30?: number
  used_90?: number
}

export interface UserTileInfo {
  name?: string
  account_id?: string
  last_active_time?: number
  group_cnt?: number
  role_cnt?: number
  entity_id?: string
}

export interface InstanceTileInfo {
  name?: string
  entity_id?: string
  account_id?: string
  last_active_time?: number
  network_cnt?: number
  vpc_id?: string
}

export interface RoleTileInfo {
  name?: string
  entity_id?: string
  account_id?: string
  last_active_time?: number
  used_read_cnt?: number
  used_write_cnt?: number
  used_admin_cnt?: number
  total_read_cnt?: number
  total_write_cnt?: number
  total_admin_cnt?: number
  policies?: string[]
  policies_count?: number
}

export interface IdentityQueryReqInternal {
  idq_req?: IdentityQueryReq
  tenant_id?: string
  use_cache?: boolean
}

export interface ObjectQueryReqInternal {
  obj_req?: ObjectQueryReq
  tenant_id?: string
  use_cache?: boolean
}

export interface UnusedRoleRow {
  common_info?: CommonDetail
  attached_identities_count?: number
  unused_privileges_count?: number
  attached_policies_count?: number
  last_accessed_time?: string
}

export interface UnusedRolesSummary {
  items?: UnusedRoleRow[]
}

export interface UnusedIdentityRow {
  common_info?: CommonDetail
  unused_roles_count?: number
  unused_privileges_count?: number
}

export interface UnusedIdentityWithoutRoleRow {
  common_info?: CommonDetail
  unused_privileges_count?: number
  attached_policies_count?: number
}

export interface UnusedIdentitySummary {
  items?: UnusedIdentityRow[]
}

export interface UnusedIdentityWithoutRoleSummary {
  items?: UnusedIdentityWithoutRoleRow[]
}

export interface UnusedIdentityWithoutRoleByFilterSummary {
  items?: UnusedIdentityWithoutRoleByFilterRow[]
}

export interface UnusedIdentityWithoutRoleByFilterRow {
  common_info?: CommonDetail
  total_count?: number
  unused_count?: number
  attached_policies_count?: number
  last_accessed_time?: string
}

export interface UnusedIdentityDetailRow {
  common_info?: CommonDetail
  unused_privileges_count?: number
  policies_count?: number
}

export interface UnusedIdentityDetail {
  items?: UnusedIdentityDetailRow[]
}

export interface UnusedRolesByFilterRow {
  common_info?: CommonDetail
  total_count?: number
  unused_count?: number
  attached_identities_count?: number
  attached_policies_count?: number
  last_accessed_time?: string
}

export interface UnusedRolesByFilterSummary {
  items?: UnusedRolesByFilterRow[]
}

export interface UnusedIdentityByFilterRow {
  common_info?: CommonDetail
  total_count?: number
  unused_count?: number
  attached_roles_count?: number
  last_accessed_time?: string
}

export interface UnusedIdentityByFilterSummary {
  items?: UnusedIdentityByFilterRow[]
}

export interface DetailRow {
  name?: string
  policies?: string
  service_name?: string
  uri?: string
}

export interface CommonDetail {
  name?: string
  uri?: string
  account_id?: string
  scope?: string
}

export interface UnusedRolesByFilterDetail {
  items?: DetailRow[]
}

export interface UnusedIdentityByFilterDetailRow {
  common_info?: CommonDetail
  total_count?: number
  unused_count?: number
  last_accessed_time?: string
}

export interface UnusedIdentityWithoutRoleByFilterDetail {
  items?: DetailRow[]
}

export interface UnusedIdentityByFilterDetail {
  items?: UnusedIdentityByFilterDetailRow[]
}

export interface UnusedIdentityByFilterByRoleDetail {
  items?: DetailRow[]
}

export interface UnusedAccessReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  identity_type?: UnusedIdentityType
  request_type?: UnusedRequestType
  identity_uri?: string
  role_uri?: string
  use_cache?: boolean
}

export interface UnusedAccessResp {
  resp_hdr?: base.RespHdr
  roles?: UnusedRolesSummary
  roles_by_service?: UnusedRolesByFilterSummary
  roles_by_privilege?: UnusedRolesByFilterSummary
  role_service_detail?: UnusedRolesByFilterDetail
  role_privilege_detail?: UnusedRolesByFilterDetail
  identities?: UnusedIdentitySummary
  identity_detail?: UnusedIdentityDetail
  identities_by_service?: UnusedIdentityByFilterSummary
  identities_by_privilege?: UnusedIdentityByFilterSummary
  identity_by_service?: UnusedIdentityByFilterDetail
  identity_by_privilege?: UnusedIdentityByFilterDetail
  identity_by_service_by_role?: UnusedIdentityByFilterByRoleDetail
  identity_by_privilege_by_role?: UnusedIdentityByFilterByRoleDetail
  identities_without_role?: UnusedIdentityWithoutRoleSummary
  identities_without_role_by_service?: UnusedIdentityWithoutRoleByFilterSummary
  identities_without_role_by_privilege?: UnusedIdentityWithoutRoleByFilterSummary
  identity_without_role_by_service?: UnusedIdentityWithoutRoleByFilterDetail
  identity_without_role_by_privilege?: UnusedIdentityWithoutRoleByFilterDetail
  top_level_count_for_unused_access?: TopLevelCountForUnusedAccess
  usage_onboarding_in_progress?: string[]
}

export interface UnusedAccessReportReq {
  req_hdr?: base.ReqHdr
  account_id?: string
  identity_type?: UnusedIdentityType
  request_type?: UnusedRequestType
  identity_uri?: string
  role_uri?: string
  selected_uri?: string
  filtered_items?: string[]
}

export interface TopLevelCountForUnusedAccess {
  items?: number
  by_services?: number
  by_privileges?: number
}

export interface HealthStatusReq {
  req_hdr?: base.ReqHdr
}

export interface HealthStatusResp {
  resp_hdr?: base.RespHdr
}

export interface NativeIdentifier {
  native_id?: string
  csp_type?: base.CloudTypeEnum
  display_name?: string
  uri?: string
}

export interface ListGroupsReq {
  req_hdr?: base.ReqHdr
  limit?: number
  offset?: number
  idp_type?: base.CloudTypeEnum
  csp_type?: base.CloudTypeEnum
  is_federated?: boolean
}

export interface ListGroupsResp {
  resp_hdr?: base.RespHdr
  groups?: NativeIdentifier[]
}

export interface GetGroupReq {
  req_hdr?: base.ReqHdr
  idp_type?: base.CloudTypeEnum
  native_id?: string
  limit?: number
  token?: string
  allow_empty_services?: boolean
}

export interface GetGroupReqInternal {
  group_req?: GetGroupReq
  tenant_id?: string
}

export interface FederatedRoleSummary {
  role?: NativeIdentifier
  admin_count?: number
  write_count?: number
  read_count?: number
  scopes?: ScopeSummary[]
}

export interface FederatedRolesList {
  items?: FederatedRoleSummary[]
}

export interface ServicesList {
  items?: ServiceSummary[]
}

export interface GetRoleReqInternal {
  role_req?: GetRoleReq
  tenant_id?: string
}

export interface GetGroupResp {
  resp_hdr?: base.RespHdr
  response_type?: GetGroupResp_GetGroupResponseType
  roles?: FederatedRolesList
  services?: ServicesList
  id?: NativeIdentifier
  prev_token?: string
  next_token?: string
}

export enum GetGroupResp_GetGroupResponseType {
  UNKNOWN = 'UNKNOWN',
  ROLES = 'ROLES',
  SERVICES = 'SERVICES'
}

export interface GetScopeReq {
  req_hdr?: base.ReqHdr
  uri?: string
  limit?: number
  token?: string
  allow_empty_services?: boolean
}

export interface ScopeSummary {
  id?: NativeIdentifier
  admin_count?: number
  write_count?: number
  read_count?: number
  num_resources?: number
}

export interface GetScopeResp {
  resp_hdr?: base.RespHdr
  services?: ServiceSummary[]
  prev_token?: string
  next_token?: string
  id?: NativeIdentifier
}

export interface ScopesList {
  items?: ScopeSummary[]
}

export interface ServiceSummary {
  name?: string
  type?: string
  num_resources?: number
}

export interface GetServiceReq {
  req_hdr?: base.ReqHdr
  uri?: string
  type?: string
  limit?: number
  token?: string
}

export interface ResourceDetail {
  id?: NativeIdentifier
  policies?: base.PolicyDetails[]
  actions?: string
}

export interface GetServiceResp {
  resp_hdr?: base.RespHdr
  resources?: ResourceDetail[]
  prev_token?: string
  next_token?: string
  id?: NativeIdentifier
}

export interface GetRoleReq {
  req_hdr?: base.ReqHdr
  native_id?: string
  group_uri?: string
  csp_type?: base.CloudTypeEnum
  limit?: number
  token?: string
}

export interface GetRoleResp {
  resp_hdr?: base.RespHdr
  scope_summary?: ScopeSummary[]
  prev_token?: string
  next_token?: string
  id?: NativeIdentifier
}

export interface ReleaseDBSessionsInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  session_max_lifetime?: string
}

export interface ReleaseDBSessionsInternalResp {
  resp_hdr?: base.RespHdr
}

export interface InitiateDataDownloadReq {
  req_hdr?: base.ReqHdr
  resource_list?: MetaResourceType[]
  cloud_type?: base.CloudTypeEnum
  filtered_id_list?: NativeIdentifier[]
  group_id?: string
}

export interface InitiateDataDownloadResp {
  resp_hdr?: base.RespHdr
}

export interface PublishEvent {
  native_id?: string
  uri?: string
  cloud_type?: base.CloudTypeEnum
  resource_event_type?: ResourceEventType
}

export interface PublishEventsInternalReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  publish_events?: PublishEvent[]
}

export interface PublishEventsInternalResp {
  resp_hdr?: base.RespHdr
}

export enum DataType {
  DATA_TYPE_UNKNOWN = 'DATA_TYPE_UNKNOWN',
  INFO = 'INFO',
  ROLL_UP_GRAPH = 'ROLL_UP_GRAPH',
  DATA_TYPE_GRAPH = 'DATA_TYPE_GRAPH',
  IDENTITY_POLICY = 'IDENTITY_POLICY',
  TABLE_DATA = 'TABLE_DATA',
  POLICY_LIST = 'POLICY_LIST'
}

export enum IdentityTileType {
  TILE_TYPE_UNKNOWN = 'TILE_TYPE_UNKNOWN',
  TILE_OBJECT = 'TILE_OBJECT',
  TILE_PRIVILEGE = 'TILE_PRIVILEGE',
  TILE_ROLE = 'TILE_ROLE',
  TILE_MEMBER = 'TILE_MEMBER',
  TILE_SCOPE = 'TILE_SCOPE',
  TILE_INSTANCE = 'TILE_INSTANCE',
  TILE_USER = 'TILE_USER',
  TILE_ADMIN = 'TILE_ADMIN'
}

export enum NetworkTileType {
  TILE_NETWORK_TYPE_UNKNOWN = 'TILE_NETWORK_TYPE_UNKNOWN',
  TILE_NETWORK_OBJECTS = 'TILE_NETWORK_OBJECTS',
  TILE_NETWORK_ROLES = 'TILE_NETWORK_ROLES',
  TILE_NETWORK_IAM = 'TILE_NETWORK_IAM',
  TILE_NETWORK_NETWORKING = 'TILE_NETWORK_NETWORKING'
}

export enum NetworkTableTab {
  TABLE_TAB_NONE = 'TABLE_TAB_NONE',
  TABLE_TAB_IAM_USER = 'TABLE_TAB_IAM_USER',
  TABLE_TAB_IAM_GROUP = 'TABLE_TAB_IAM_GROUP',
  TABLE_TAB_IAM_ROLE = 'TABLE_TAB_IAM_ROLE',
  TABLE_TAB_NETWORKING_INSTANCES = 'TABLE_TAB_NETWORKING_INSTANCES',
  TABLE_TAB_NETWORKING_SECURITY_GROUPS = 'TABLE_TAB_NETWORKING_SECURITY_GROUPS',
  TABLE_TAB_NETWORKING_SUBNETS = 'TABLE_TAB_NETWORKING_SUBNETS',
  TABLE_TAB_NETWORKING_RULES = 'TABLE_TAB_NETWORKING_RULES',
  TABLE_TAB_NETWORKING_ROUTES = 'TABLE_TAB_NETWORKING_ROUTES'
}

export enum queryFsmState {
  FSM_STATE_UNKNOWN = 'FSM_STATE_UNKNOWN',
  START = 'START',
  ACCESS = 'ACCESS',
  NOT = 'NOT',
  OR = 'OR',
  AND = 'AND',
  FOR = 'FOR',
  ANY = 'ANY',
  WITH = 'WITH',
  VIA = 'VIA',
  RESOURCE_TYPE = 'RESOURCE_TYPE',
  IDENTITY_TYPE = 'IDENTITY_TYPE',
  VIA_TYPE = 'VIA_TYPE',
  RESOURCE_NAME = 'RESOURCE_NAME',
  IDENTITY_NAME = 'IDENTITY_NAME',
  VIA_NAME = 'VIA_NAME',
  RESOURCE_TYPE_ATTRIBUTES = 'RESOURCE_TYPE_ATTRIBUTES',
  IDENTITY_TYPE_ATTRIBUTES = 'IDENTITY_TYPE_ATTRIBUTES',
  VIA_TYPE_ATTRIBUTES = 'VIA_TYPE_ATTRIBUTES',
  ATTRIBUTES_VALUE = 'ATTRIBUTES_VALUE',
  ATTRIBUTES_VALUE_NEXT = 'ATTRIBUTES_VALUE_NEXT',
  IDENTITY_ANY = 'IDENTITY_ANY',
  OBJECT = 'OBJECT',
  OBJECT_NAME = 'OBJECT_NAME',
  END = 'END',
  ACTION_TYPE = 'ACTION_TYPE',
  READING_USAGE_OPERATOR = 'READING_USAGE_OPERATOR',
  READING_USAGE_GT_OPERAND = 'READING_USAGE_GT_OPERAND',
  READING_USAGE_LT_OPERAND = 'READING_USAGE_LT_OPERAND',
  READING_ACTION_TYPE = 'READING_ACTION_TYPE',
  READING_XACCOUNT_TYPE = 'READING_XACCOUNT_TYPE',
  READING_ACTION = 'READING_ACTION',
  WITH_ROLE = 'WITH_ROLE',
  WITH_SCOPE = 'WITH_SCOPE'
}

export enum FSMStage {
  STAGE_UNKNOWN = 'STAGE_UNKNOWN',
  IDENTITY = 'IDENTITY',
  ATTRIBUTE = 'ATTRIBUTE',
  RESOURCE = 'RESOURCE',
  STAGE_VIA = 'STAGE_VIA',
  PRIVILEGE = 'PRIVILEGE'
}

export enum AutoCompleteRespTypeEnum {
  AUTO_COMPLETE_RESP_TYPE_UNKNOWN = 'AUTO_COMPLETE_RESP_TYPE_UNKNOWN',
  AUTO_COMPLETE_RESP_TYPE_USAGE = 'AUTO_COMPLETE_RESP_TYPE_USAGE'
}

export enum ObjectTileType {
  OBJECT_TILE_TYPE_UNKNOWN = 'OBJECT_TILE_TYPE_UNKNOWN',
  OBJECT_TILE_IDENTITY = 'OBJECT_TILE_IDENTITY',
  OBJECT_TILE_ACCESS = 'OBJECT_TILE_ACCESS',
  OBJECT_TILE_MEMBERSHIP = 'OBJECT_TILE_MEMBERSHIP'
}

export enum ShadowType {
  SHADOW_UNKNOWN_ACCOUNT = 'SHADOW_UNKNOWN_ACCOUNT',
  SHADOW_KNOWN_ACCOUNT = 'SHADOW_KNOWN_ACCOUNT',
  SHADOW_KNOWN_NETWORK = 'SHADOW_KNOWN_NETWORK'
}

export enum UnusedIdentityType {
  UNUSED_IDENTITY_UNKNOWN = 'UNUSED_IDENTITY_UNKNOWN',
  UNUSED_ROLE = 'UNUSED_ROLE',
  UNUSED_IDENTITY = 'UNUSED_IDENTITY',
  UNUSED_IDENTITY_WITHOUT_ROLE = 'UNUSED_IDENTITY_WITHOUT_ROLE'
}

export enum UnusedRequestType {
  REQUEST_TYPE_UNKNOWN = 'REQUEST_TYPE_UNKNOWN',
  UNUSED_SUMMARY = 'UNUSED_SUMMARY',
  UNUSED_DETAIL = 'UNUSED_DETAIL',
  UNUSED_BY_SERVICE_SUMMARY = 'UNUSED_BY_SERVICE_SUMMARY',
  UNUSED_BY_SERVICE_DETAIL = 'UNUSED_BY_SERVICE_DETAIL',
  UNUSED_BY_PRIVILEGE_SUMMARY = 'UNUSED_BY_PRIVILEGE_SUMMARY',
  UNUSED_BY_PRIVILEGE_DETAIL = 'UNUSED_BY_PRIVILEGE_DETAIL'
}

export enum MetaResourceType {
  META_RESOURCE_TYPE_UNKNOWN = 'META_RESOURCE_TYPE_UNKNOWN',
  META_RESOURCE_TYPE_GROUP = 'META_RESOURCE_TYPE_GROUP',
  META_RESOURCE_TYPE_ROLE = 'META_RESOURCE_TYPE_ROLE'
}

export enum ResourceEventType {
  EVENT_UNKNOWN = 'EVENT_UNKNOWN',
  EVENT_CREATE = 'EVENT_CREATE',
  EVENT_DELETE = 'EVENT_DELETE',
  EVENT_UPDATE = 'EVENT_UPDATE'
}

export enum EventType {
  ROLE_CREATE = 'ROLE_CREATE',
  ROLE_UPDATE = 'ROLE_UPDATE',
  ROLE_DELETE = 'ROLE_DELETE',
  GROUP_CREATE = 'GROUP_CREATE',
  GROUP_UPDATE = 'GROUP_UPDATE',
  GROUP_DELETE = 'GROUP_DELETE'
}
